/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { testAttributes, tableIds } from './Constants';
import '../../../StyleGuide/styles/global.skeleton.scss';

import {
    tableWrapper,
    table,
    stickyClass,
    colorStripes,
    genericBackgroundColor,
    disclaimerStyle,
    skeletonRow,
} from './RateTable.module.scss';

const Skeleton = ({ columns, skeletonRows }) =>
    [...Array(skeletonRows).keys()].map((tr) => (
        <tr key={`tr-${tr}`}>
            {columns.map((item) => (
                <td key={`row-${tr}-${item}`}>
                    <span className={`skeleton-box ${skeletonRow}`} />
                </td>
            ))}
        </tr>
    ));

const RateTable = ({
    tableHeaders,
    tableData,
    disclaimer = false,
    stickyScrollWidth = undefined,
    isStripesColors = false,
    isLoading = false,
    skeletonRows = undefined,
}) => (
    <div
        data-testid={testAttributes.RATE_TABLE_CONTAINER}
        className="rate-table-container"
    >
        <div
            data-testid={testAttributes.RATE_TABLE}
            className={`${tableWrapper} ${stickyScrollWidth !== undefined ? stickyClass : null}`}
        >
            <table
                className={`${table} rate-table`}
                style={
                    stickyScrollWidth !== undefined
                        ? { minWidth: stickyScrollWidth }
                        : null
                }
            >
                <thead data-testid={testAttributes.RATE_TABLE_HEAD}>
                    <tr>
                        {tableHeaders?.map((column, index) => (
                            <th key={`${tableIds.COLUMN_ID}${index}`}>
                                {column}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody data-testid={testAttributes.RATE_TABLE_BODY}>
                    {tableData?.map((rowItem, index) => (
                        <tr
                            className={`${isStripesColors ? colorStripes : genericBackgroundColor}`}
                            key={`${tableIds.COLUMN_ID}${tableIds.ROW_ID}${index}`}
                        >
                            {rowItem.map((item, idx) => (
                                <td key={`${tableIds.ROW_ID}${idx}`}>{item}</td>
                            ))}
                        </tr>
                    ))}
                    {isLoading && (
                        <Skeleton
                            columns={tableHeaders}
                            skeletonRows={skeletonRows}
                        />
                    )}
                </tbody>
            </table>
        </div>
        {disclaimer && (
            <div
                data-testid={testAttributes.RATE_TABLE_DISCLAIMER}
                className={disclaimerStyle}
            >
                <p>{disclaimer}</p>
            </div>
        )}
    </div>
);

RateTable.propTypes = {
    /** Table Header prop array */
    tableHeaders: PropTypes.array.isRequired,
    /** Table prop, array of arrays [it can be jsx component or string] */
    tableData: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.array)])
        .isRequired,
    /** Disclaimer, legal rates information */
    disclaimer: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    /** Sticky Scroll Width prop, used to determine independent styles when the table belongs to Mortgage rates page */
    stickyScrollWidth: PropTypes.string,
    /** isStripesColors define when rows color should be as color stripes or no */
    isStripesColors: PropTypes.bool,
    /** isLoading define when loading state is set to show skeleton */
    isLoading: PropTypes.bool,
    /** skeletonRows define rows to show in loading state */
    skeletonRows: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.oneOf([undefined]),
    ]),
};

export default RateTable;
